<div class="container">
  <div class="header">
    <p>Switch order’s package?</p>
    <pdq-button
      (onClick)="onClose()"
      [disabled]="loadingConfirm"
      variant="ghost"
      iconColor="var(--on-surface-light)"
      icon="close"></pdq-button>
  </div>
  <div class="content">
    <div class="content__comment">
      Heads up, switching an order’s package changes its shipping rate and so requires a new shipping label
    </div>
    <package-form
      [disableShippingWeightInput]="data?.order?.extraBoxes?.length"
      [initialBox]="initialBox"
      [shopBoxes]="shopBoxes"
      [packageForm]="packageForm"
      [initialWeight]="initialShippingWeight"
      [showShippingWeight]="!isMultiParcel"
      [showCustomBox]="!isMultiParcel"
      (onTabChange)="setPackageType($event)"></package-form>
    <div class="content__rates">
      <pdq-button
        [disabled]="packageForm?.pristine === true || loadingConfirm"
        [loading]="loadingRates"
        variant="secondary"
        (onClick)="previewRates()"
        label="Get rate"></pdq-button>
      @if (rateStr) {
        <div class="content_rates__rate">
          <div class="content__rates__rate__title">Shipping price for this package:</div>
          <div class="content__rates__rate__value">
            {{ rateStr }}
          </div>
        </div>
      }
    </div>
  </div>
  <div class="footer">
    <pdq-button
      [disabled]="loadingConfirm"
      (onClick)="onClose()"
      size="large"
      variant="light"
      label="Cancel"></pdq-button>
    <pdq-button
      [disabled]="loadingRates || !changesLastSnapshot"
      [loading]="loadingConfirm"
      (onClick)="onConfirm()"
      size="large"
      variant="primary"
      label="Confirm"></pdq-button>
  </div>
</div>
